import { useState, useEffect } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import CriteriaSettings from "@/components/CriteriaSettings";
import PerformanceThresholdSettings from "@/components/PerformanceThresholdSettings";
import RatingModeSettings, { RatingMode } from "@/components/RatingModeSettings";
import { Criteria } from "@/types/criteria";
import { PerformanceThreshold } from "@/types/performanceThresholds";
import { Target, Gauge, SlidersHorizontal } from "lucide-react";

interface EvaluationSettingsProps {
  criteria: Criteria[];
  thresholds: PerformanceThreshold[];
  onSaveCriteria: (criteria: Criteria[]) => void;
  onSaveThresholds: (thresholds: PerformanceThreshold[]) => void;
}

const EvaluationSettings = ({
  criteria,
  thresholds,
  onSaveCriteria,
  onSaveThresholds,
}: EvaluationSettingsProps) => {
  const [activeTab, setActiveTab] = useState("criteria");
  const [ratingMode, setRatingMode] = useState<RatingMode>(() => {
    const stored = localStorage.getItem("ratingMode");
    // Default to slider mode
    return (stored as RatingMode) || "slider";
  });

  const handleSaveRatingMode = (mode: RatingMode) => {
    localStorage.setItem("ratingMode", mode);
    setRatingMode(mode);
    window.dispatchEvent(new Event('storage-sync'));
  };

  return (
    <div className="space-y-6">
      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="grid w-full grid-cols-3 max-w-lg">
          <TabsTrigger value="criteria" className="flex items-center gap-2">
            <Target className="h-4 w-4" />
            Kriterien
          </TabsTrigger>
          <TabsTrigger value="thresholds" className="flex items-center gap-2">
            <Gauge className="h-4 w-4" />
            Schwellenwerte
          </TabsTrigger>
          <TabsTrigger value="ratingmode" className="flex items-center gap-2">
            <SlidersHorizontal className="h-4 w-4" />
            Modus
          </TabsTrigger>
        </TabsList>

        <TabsContent value="criteria" className="mt-6">
          <CriteriaSettings criteria={criteria} onSave={onSaveCriteria} />
        </TabsContent>

        <TabsContent value="thresholds" className="mt-6">
          <PerformanceThresholdSettings thresholds={thresholds} onSave={onSaveThresholds} />
        </TabsContent>

        <TabsContent value="ratingmode" className="mt-6">
          <RatingModeSettings ratingMode={ratingMode} onSave={handleSaveRatingMode} />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default EvaluationSettings;
